module.exports = __webpack_public_path__ + "static/b6-79f527965d4166a36170d2d3c95ed785.png";